module.exports = __webpack_public_path__ + "img/XSurfLog_White.bd47a9a7.svg";